import React from 'react';
import Box from '@mui/material/Box';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import ToggleButton from '@mui/material/ToggleButton';
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import CheckIcon from '@mui/icons-material/Check';
import { SectionCard } from '../../../components/Section';
import { PlanRulesDraft, PlanRulesView } from '../../../types/planRules';
import { planLabel, ruleKey } from './premium.helpers';

interface PremiumServicesProps {
  draft: PlanRulesDraft;
  services: PlanRulesView['services'];
  onServiceChange: (planId: number, serviceId: number, included: boolean) => void;
}

/** Extra features each plan includes. New services need app work, so only developers add them. */
export function PremiumServices({ draft, services, onServiceChange }: PremiumServicesProps) {
  return (
    <SectionCard
      title="Services"
      description="Extra features each plan includes. A new service needs app work, so it's added by developers."
      disablePadding
    >
      <Box sx={{ overflowX: 'auto' }}>
        <Table size="small" aria-label="Services per plan">
          <TableHead>
            <TableRow>
              <TableCell>Service</TableCell>
              {draft.plans.map((plan) => (
                <TableCell key={plan.id} sx={{ fontWeight: 600 }}>
                  {planLabel(plan)}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {services.map((service) => (
              <TableRow key={service.id}>
                <TableCell sx={{ fontWeight: 600 }}>{service.name}</TableCell>
                {draft.plans.map((plan) => {
                  const included = Boolean(draft.serviceRules[ruleKey(plan.id, service.id)]);

                  return (
                    <TableCell key={plan.id}>
                      <ToggleButtonGroup
                        exclusive
                        size="small"
                        value={included ? 'included' : 'excluded'}
                        onChange={(event, next) => next && onServiceChange(plan.id, service.id, next === 'included')}
                        aria-label={`${service.name} in ${plan.name}`}
                      >
                        <ToggleButton value="excluded" sx={{ textTransform: 'none', gap: '4px' }}>
                          <LockOutlinedIcon fontSize="inherit" /> Not included
                        </ToggleButton>
                        <ToggleButton value="included" sx={{ textTransform: 'none', gap: '4px' }}>
                          <CheckIcon fontSize="inherit" /> Included
                        </ToggleButton>
                      </ToggleButtonGroup>
                    </TableCell>
                  );
                })}
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </Box>
    </SectionCard>
  );
}
